function checkBrowser() {
    const agents = {
        chrome: isChrome(),
        IExplorer: isIExplorer(),
        firefox: isFirefox(),
        safari: isSafari(),
        opera: isOpera(),
    };


    for (const [key, value] of Object.entries(agents)) {
        if (value) {
            document.body.classList.add(key);
        }
    }
}

const isChrome = () => {
    let operaAgent = isOpera();
    let chromeAgent = navigator.userAgent.indexOf('Chrome') > -1;
    // Discard Chrome since it also matches Opera
    if ((chromeAgent) && (operaAgent)) {
        chromeAgent = false;
    }

    return chromeAgent;
};
const isIExplorer = () => navigator.userAgent.indexOf('MSIE') > -1 || navigator.userAgent.indexOf('rv:') > -1;
const isFirefox = () => navigator.userAgent.indexOf('Firefox') > -1;
const isSafari = () => {
    let chromeAgent = isChrome();
    let safariAgent = navigator.userAgent.indexOf('Safari') > -1;

    // Discard Safari since it also matches Chrome
    if ((chromeAgent) && (safariAgent)) {
        safariAgent = false;
    }

    return safariAgent;
};
const isOpera = () => navigator.userAgent.indexOf('OP') > -1;

export {isIExplorer, isFirefox, isSafari, isOpera, isChrome, checkBrowser};